import React from 'react';
import { Table, TableBody } from '@mui/material';
import {
    renderTableRowsByDataType,
    TableDetailsData,
    tableStyles,
} from './details-table-helpers';

interface TableDetailsProps {
    data: TableDetailsData;
}
// This Component will dynamically render its rows based on the row data type: List, Object, primitive data type.
const DataDetailsTable = ({ data }: TableDetailsProps): React.JSX.Element => {
    return (
        <Table sx={tableStyles.externalTable}>
            <TableBody>
                {React.Children.toArray(
                    Object.keys(data).map((key) =>
                        renderTableRowsByDataType(data[key], key)
                    )
                )}
            </TableBody>
        </Table>
    );
};

export default DataDetailsTable;
